import * as React from "react";
const SvgIconPolygon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 9, height: 8, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m4.5.5 3.897 6.75H.603z" }));
export default SvgIconPolygon;
